import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, IconButton, Stack, Toolbar, Typography } from '@mui/material';
import { get } from 'lodash';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks';
import { LangSwitcher } from '../lang-switcher';
import { UserMenu } from '../user-menu';
import useStyles from './styles';

interface CabinetHeaderProps {
  handleDrawerToggle: () => void;
}

export const CabinetHeader: ComponentType<CabinetHeaderProps> = ({ handleDrawerToggle }) => {
  const classes = useStyles();
  const { user } = useAuth();
  const { i18n } = useTranslation();

  const organization = get(user, ['data', 'organization', 'title', i18n.language], null);

  return (
    <AppBar position="static" className={classes.root} elevation={0}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        {organization && <Typography variant="body2">{organization}</Typography>}
        {/* right panel */}
        <Stack direction="row" ml="auto" alignItems="center">
          {/* right panel: language switcher */}
          <LangSwitcher sx={{ ml: 2 }} />
          {/* right panel: user menu */}
          <UserMenu sx={{ ml: 2 }} />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
